export const defaultTextColors = {
  black: {
    rgba: {
      r: '0',
      g: '0',
      b: '0',
      a: '1',
    },
  },
  white: {
    rgba: {
      r: '255',
      g: '255',
      b: '255',
      a: '1',
    },
  },
};

export const defaultBackgroundColor = {
  rgba: {
    r: '74',
    g: '144',
    b: '226',
    a: '1',
  },
};

export const defaultTextColor = {
  rgba: {
    r: '84',
    g: '93',
    b: '108',
    a: '1',
  },
};

export const defaultRadioButtonColors = {
  on_background: {
    rgba: {
      r: '74',
      g: '144',
      b: '226',
      a: '1',
    },
  },
  on_label: {
    rgba: {
      r: '30',
      g: '30',
      b: '30',
      a: '1',
    },
  },
  on_border: {
    rgba: {
      r: '74',
      g: '144',
      b: '226',
      a: '1',
    },
  },
  off_background: {
    rgba: {
      r: '255',
      g: '255',
      b: '255',
      a: '1',
    },
  },
  off_border: {
    rgba: {
      r: '161',
      g: '174',
      b: '183',
      a: '1',
    },
  },
  off_label: {
    rgba: {
      r: '30',
      g: '30',
      b: '30',
      a: '1',
    },
  },
};

export const defaultButtonColors = {
  primary: {
    text: {
      rgba: {
        r: '255',
        g: '255',
        b: '255',
        a: '1',
      },
    },
    background: {
      rgba: {
        r: '74',
        g: '144',
        b: '226',
        a: '1',
      },
    },
    hover_background: {
      rgba: {
        r: '132',
        g: '179',
        b: '235',
        a: '1',
      },
    },
  },
  secondary: {
    text: {
      rgba: {
        r: '30',
        g: '30',
        b: '30',
        a: '1',
      },
    },
    background: {
      rgba: {
        r: '255',
        g: '255',
        b: '255',
        a: '1',
      },
    },
    hover_background: {
      rgba: {
        r: '74',
        g: '144',
        b: '226',
        a: '1',
      },
    },
    hover_text: {
      rgba: {
        r: '30',
        g: '30',
        b: '30',
        a: '1',
      },
    },
    border: {
      rgba: {
        r: '30',
        g: '30',
        b: '30',
        a: '1',
      },
    },
  },
};

export const defaultInputColors = {
  background: {
    rgba: {
      r: '255',
      g: '255',
      b: '255',
      a: '1',
    },
  },
  text: {
    rgba: {
      r: '74',
      g: '144',
      b: '226',
      a: '1',
    },
  },
  border: {
    rgba: {
      r: '161',
      g: '174',
      b: '183',
      a: '1',
    },
  },
  error_border: {
    rgba: {
      r: '199',
      g: '32',
      b: '20',
      a: '1',
    },
  },
  placeholder: {
    rgba: {
      r: '161',
      g: '174',
      b: '183',
      a: '1',
    },
  },
  disabled_background: {
    rgba: {
      r: '246',
      g: '247',
      b: '248',
      a: '1',
    },
  },
};

export const defaultCheckboxColors = {
  on_background: {
    rgba: {
      r: '74',
      g: '144',
      b: '226',
      a: '1',
    },
  },
  on_label: {
    rgba: {
      r: '30',
      g: '30',
      b: '30',
      a: '1',
    },
  },
  on_border: {
    rgba: {
      r: '74',
      g: '144',
      b: '226',
      a: '1',
    },
  },
  on_hook: {
    rgba: {
      r: '255',
      g: '255',
      b: '255',
      a: '1',
    },
  },
  off_background: {
    rgba: {
      r: '255',
      g: '255',
      b: '255',
      a: '1',
    },
  },
  off_border: {
    rgba: {
      r: '161',
      g: '174',
      b: '183',
      a: '1',
    },
  },
  off_label: {
    rgba: {
      r: '30',
      g: '30',
      b: '30',
      a: '1',
    },
  },
};

export const defaultDropdownColors = {
  background: {
    rgba: {
      r: '255',
      g: '255',
      b: '255',
      a: '1',
    },
  },
  text: {
    rgba: {
      r: '30',
      g: '30',
      b: '30',
      a: '1',
    },
  },
  border: {
    rgba: {
      r: '161',
      g: '174',
      b: '183',
      a: '1',
    },
  },
  opened_border: {
    rgba: {
      r: '30',
      g: '30',
      b: '30',
      a: '1',
    },
  },
  disabled_background: {
    rgba: {
      r: '246',
      g: '247',
      b: '248',
      a: '1',
    },
  },
  placeholder_color: {
    rgba: {
      r: '161',
      g: '174',
      b: '183',
      a: '1',
    },
  },
  label_background: {
    rgba: {
      r: '74',
      g: '144',
      b: '226',
      a: '1',
    },
  },
  label_text: {
    rgba: {
      r: '255',
      g: '255',
      b: '255',
      a: '1',
    },
  },
};

export const defaultLeftSideNavColors = {
  background: {
    rgba: {
      r: '74',
      g: '144',
      b: '226',
      a: '1',
    },
  },
  text: {
    rgba: {
      r: '84',
      g: '93',
      b: '108',
      a: '1',
    },
  },
  menu_background: {
    rgba: {
      r: '74',
      g: '144',
      b: '226',
      a: '1',
    },
  },
  menu_text: {
    rgba: {
      r: '84',
      g: '93',
      b: '108',
      a: '1',
    },
  },
  sub_menu_background: {
    rgba: {
      r: '74',
      g: '144',
      b: '226',
      a: '1',
    },
  },
  sub_menu_text: {
    rgba: {
      r: '84',
      g: '93',
      b: '108',
      a: '1',
    },
  },
};

export const defaultToggleButtonColors = {
  background: {
    rgba: {
      r: '74',
      g: '144',
      b: '226',
      a: '1',
    },
  },
  text: {
    rgba: {
      r: '84',
      g: '93',
      b: '108',
      a: '1',
    },
  },
  off_background: {
    rgba: {
      r: '74',
      g: '144',
      b: '226',
      a: '1',
    },
  },
  off_text: {
    rgba: {
      r: '84',
      g: '93',
      b: '108',
      a: '1',
    },
  },
  label: {
    rgba: {
      r: '84',
      g: '93',
      b: '108',
      a: '1',
    },
  },
  off_label: {
    rgba: {
      r: '84',
      g: '93',
      b: '108',
      a: '1',
    },
  },
};

export const defaultExplanationBoxColors = {
  background: {
    rgba: {
      r: '254',
      g: '245',
      b: '232',
      a: '1',
    },
  },
  text: {
    rgba: {
      r: '0',
      g: '0',
      b: '0',
      a: '1',
    },
  },
  button_text: {
    rgba: {
      r: '0',
      g: '0',
      b: '0',
      a: '1',
    },
  },
  button_background: {
    rgba: {
      r: '254',
      g: '245',
      b: '232',
      a: '1',
    },
  },
};

export const defaultAvatarColors = {
  background: {
    rgba: {
      r: '242',
      g: '247',
      b: '253',
      a: '1',
    },
  },
  color: {
    rgba: {
      r: '74',
      g: '144',
      b: '226',
      a: '1',
    },
  },
};

export const defaultTableColors = {
  background: {
    rgba: {
      r: '255',
      g: '255',
      b: '255',
      a: '1',
    },
  },
  text: {
    rgba: {
      r: '90',
      g: '92',
      b: '108',
      a: '1',
    },
  },
  header_background: {
    rgba: {
      r: '74',
      g: '144',
      b: '226',
      a: '1',
    },
  },
  header_text: {
    rgba: {
      r: '255',
      g: '255',
      b: '255',
      a: '1',
    },
  },
  stripe: {
    rgba: {
      r: '0',
      g: '0',
      b: '0',
      a: '0.05',
    },
  },
  horizontal_line: {
    rgba: {
      r: '84',
      g: '93',
      b: '108',
      a: '1',
    },
  },
  icon: {
    rgba: {
      r: '90',
      g: '92',
      b: '108',
      a: '1',
    },
  },
  disabled_icon: {
    rgba: {
      r: '90',
      g: '92',
      b: '108',
      a: '0.5',
    },
  },
};

export const defaultHorizontalTabColors = {
  background: {
    rgba: {
      r: '242',
      g: '247',
      b: '253',
      a: '0',
    },
  },
  active_color: {
    rgba: {
      r: '74',
      g: '144',
      b: '226',
      a: '1',
    },
  },
  passive_color: {
    rgba: {
      r: '102',
      g: '112',
      b: '133',
      a: '1',
    },
  },
  border: {
    rgba: {
      r: '74',
      g: '144',
      b: '226',
      a: '1',
    },
  },
};

export const defaultWorkingAreaColors = {
  background: {
    rgba: {
      r: '255',
      g: '255',
      b: '255',
      a: '1',
    },
  },
  text: {
    rgba: {
      r: '90',
      g: '92',
      b: '108',
      a: '1',
    },
  },
  burger_menu: {
    rgba: {
      r: '255',
      g: '255',
      b: '255',
      a: '1',
    },
  },
  dashboard_icon: {
    rgba: {
      r: '245',
      g: '245',
      b: '246',
      a: '1',
    },
  },
};

export const defaultMainColors = {
  background: {
    rgba: {
      r: '242',
      g: '247',
      b: '253',
      a: '1',
    },
  },
  text: {
    rgba: {
      r: '84',
      g: '93',
      b: '108',
      a: '1',
    },
  },
  title: {
    rgba: {
      r: '30',
      g: '30',
      b: '30',
      a: '1',
    },
  },
};

export const defaultModalColors = {
  background: {
    rgba: {
      r: '255',
      g: '255',
      b: '255',
      a: '1',
    },
  },
  text: {
    rgba: {
      r: '90',
      g: '92',
      b: '108',
      a: '1',
    },
  },
  body_background: {
    rgba: {
      r: '255',
      g: '255',
      b: '255',
      a: '1',
    },
  },
  edge_valid: {
    rgba: {
      r: '90',
      g: '92',
      b: '108',
      a: '1',
    },
  },
  edge_invalid: {
    rgba: {
      r: '210',
      g: '227',
      b: '248',
      a: '1',
    },
  },
};

export const defaultTooltipColors = {
  background: {
    rgba: {
      r: '255',
      g: '255',
      b: '255',
      a: '1',
    },
  },
  text: {
    rgba: {
      r: '0',
      g: '0',
      b: '0',
      a: '1',
    },
  },
  shadow: {
    rgba: {
      r: '16',
      g: '24',
      b: '40',
      a: '0.1',
    },
  },
};

export const defaultBlackoutCalendarColors = {
  background: {
    rgba: {
      r: '255',
      g: '255',
      b: '255',
      a: '1',
    },
  },
  text: {
    rgba: {
      r: '84',
      g: '93',
      b: '108',
      a: '1',
    },
  },
  border: {
    rgba: {
      r: '217',
      g: '220',
      b: '225',
      a: '1',
    },
  },
  inside_border: {
    rgba: {
      r: '161',
      g: '174',
      b: '183',
      a: '1',
    },
  },
  outside_of_month_background: {
    rgba: {
      r: '246',
      g: '247',
      b: '248',
      a: '1',
    },
  },
  header_background: {
    rgba: {
      r: '255',
      g: '255',
      b: '255',
      a: '1',
    },
  },
  content_border: {
    rgba: {
      r: '13',
      g: '13',
      b: '13',
      a: '1',
    },
  },
  blackout_true: {
    rgba: {
      r: '141',
      g: '212',
      b: '178',
      a: '1',
    },
  },
  blackout_false: {
    rgba: {
      r: '244',
      g: '138',
      b: '150',
      a: '1',
    },
  },
  disabled_date_day: {
    rgba: {
      r: '161',
      g: '174',
      b: '183',
      a: '1',
    },
  },
};

export const defaultSettingColors = {
  mainBackgroundColorType: 'FLAT',
  headerBackgroundColorType: 'FLAT',
  bookNowButtonColorType: 'FLAT',
  roomTypeBackgroundColorType: 'FLAT',
  mainBackgroundColor: '#FFFFFF',
  template_background_colour_top: '#FFFFFF',
  template_background_colour_bottom: '#FFFFFF',
  headerBackgroundColor: '#4A90E2',
  header_background_colour_top: '#4A90E2',
  header_background_colour_bottom: '#4A90E2',
  roomTypeBackgroundColor: '#FFFFFF',
  product_background_colour_top: '#FFFFFF',
  product_background_colour_bottom: '#FFFFFF',
  inputFieldsBackgroundColor: '#FFFFFF',
  searchButtonFontColor: '#FFFFFF',
  searchButtonNormalStateBackgroundColor: '#F7981C',
  searchButtonMouseHoverBackgroundColor: '#E59730',
  bookNowButtonFontColor: '#FFFFFF',
  bookNowButtonNormalStateColor: '#f7981c',
  bookNowButtonMouseHoverColor: '#39b54a',
  other_buttons_background_colour_top: '#f7981c',
  other_buttons_background_colour_bottom: '#f7981c',
  other_buttons_background_hover_colour_top: '#39b54a',
  other_buttons_background_hover_colour_bottom: '#39b54a',
  languageSelectionColor: '#666',
  date_background_colour: '#FFFFFF',
  date_colour: '#545d6c',
  roomTypeTitleColor: '#4A90E2',
  mealsIncludedColor: '#26D237',
  mealsExcludedColor: '#F52525',
  personsInfoFontColor: '#4A90E2',
  productPriceFontColor: '#4A90E2',
  roomTypeTitleFontStyle: 'NORMAL',
  personsInfoFontStyle: 'NORMAL',
  productPriceFontStyle: 'NORMAL',
  checkInOutInputColor: '#FFFFFF',
  title_bar_colour: '#91929d',
  title_bar_background_colour: '#000000',
  inputFieldsFontColor: '#666666',
  inputFieldsErrorColor: '#F52525',
  inputFieldsSuccessColor: '#26D237',
  descriptionRoomRateFontColor: '#66666c',
  showOnMapButtonColorType: 'FLAT',
  showOnMapButtonNormalStateColor: '#A59945',
  showOnMapButtonMouseHoverColor: '#1CF7BB',
  showOnMapButtonFontColor: '#FFFFFF',
  infoBoxFontColor: '#000000',
  infoBoxBackgroundColor: '#FFFFFF',
  confirmationEmailTopLineColor: '#4a90e2',
  confirmationEmailResponseButtonBackgroundColor: '#80b1eb',
  confirmationEmailResponseButtonFontColor: '#ffffff',
  calendarCheckInOutFontColor: '#FFFFFF',
  calendarCheckInOutBackgroundColor: '#F7981C',
  calendarCheckInOutBetweenFontColor: '#F7981C',
  calendarCheckInOutBetweenBackgroundColor: '#FEF0DD',
  promotionTagBackgroundColor: '#FFFFFF',
  promotionTagBorderColor: '#ffa93c',
  promotionTagFontColor: '#ffa93c',
};

export default {
  defaultTextColors,
  defaultBackgroundColor,
  defaultInputColors,
  defaultButtonColors,
  defaultHorizontalTabColors,
  defaultDropdownColors,
  defaultLeftSideNavColors,
  defaultToggleButtonColors,
  defaultExplanationBoxColors,
  defaultAvatarColors,
  defaultTableColors,
  defaultWorkingAreaColors,
  defaultMainColors,
  defaultModalColors,
  defaultTooltipColors,
  defaultCheckboxColors,
  defaultRadioButtonColors,
  defaultBlackoutCalendarColors,
  defaultSettingColors,
};
